import { render, staticRenderFns } from "./lotteryHall.vue?vue&type=template&id=4fdb97df&scoped=true"
import script from "./lotteryHall.vue?vue&type=script&lang=js"
export * from "./lotteryHall.vue?vue&type=script&lang=js"
import style0 from "./lotteryHall.vue?vue&type=style&index=0&id=4fdb97df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb97df",
  null
  
)

export default component.exports